<template>
    <Teleport defer :to="controlsTarget" :disabled="!controlsTarget">
        <div
            v-bind="$attrs"
            class="file-viewer-controls tw:flex tw:items-center"
            :class="
                controlsTarget
                    ? 'tw:flex-1 tw:min-w-0 tw:gap-1'
                    : 'tw:gap-2 tw:p-2 tw:shrink-0 tw:border-b tw:border-gray-200'
            "
        >
            <slot />
        </div>
    </Teleport>
</template>

<script setup>
import { inject } from 'vue';
import { FILE_VIEWER_CONTROLS_TARGET } from '@/composables/useFileViewer.js';

defineOptions({ inheritAttrs: false });

/**
 * Selector of the File Viewer drawer's controls slot. Renderers mounted outside the
 * drawer (or in isolation) receive null and keep their toolbar inline.
 */
const controlsTarget = inject(FILE_VIEWER_CONTROLS_TARGET, null);
</script>
